import { fetchLookbookByIdSettingsGeneral } from '@app/services/lookbookRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';

const LOOKBOOK_BY_ID_SETTINGS_GENERAL_QUERY_KEY = 'lookbookByIdSettingsGeneral';

interface Props {
  lookbookId: Nullable<string> | undefined;
}

export const useLookbookSettingsGeneral = ({ lookbookId }: Props) => {
  const isEnabled = isDefined(lookbookId);

  return useQuery({
    enabled: isEnabled,
    queryFn: isEnabled ? async () => fetchLookbookByIdSettingsGeneral(lookbookId) : skipToken,
    queryKey: [LOOKBOOK_BY_ID_SETTINGS_GENERAL_QUERY_KEY, lookbookId],
  });
};
